import React, { useState } from 'react';
import axios from '../../AxiosInstance';
import styles from './onboarding.module.css';
import { PrimaryButton, TextInput, RadioInput } from "../../components/input/inputs";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function Onboarding() {
    const {t} = useTranslation();
    const [form, setForm] = useState({ plan: 0 });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const navigate = useNavigate();

    const planOptions = [
        t('onboarding.planIndividual'),
        t('onboarding.planCorporate'),
    ];

    const handleSubmit = () => {
        if (!form.corporate_group_name || form.corporate_group_name.trim() === '') {
            setError(t('onboarding.corporateGroupRequired'));
            return;
        }

        setLoading(true);
        setError(null);

        axios.post("onboarding/setup/", {
            corporate_group_name: form.corporate_group_name.trim(),
            company_name: form.company_name?.trim() || '',
            plan: form.plan
        }).then((response) => {
            setLoading(false);
            navigate('/');
            window.location.reload();
        }).catch((err) => {
            setLoading(false);
            if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError(t('onboarding.errorCompleting'));
            }
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.background}>
                <img alt={'background'} src={'/login.png'} width={'100%'} />
            </div>

            <div className={`${styles.onboardingContainer} px-4 pt-4`}>
                <div className={styles.innerContainer}>
                    <div className={'pt-4 pb-3'}>
                        <img alt={'myindustrialdata'} src={'/logo_hd.svg'} width={'100%'} height={'70px'} style={{
                            objectFit: 'cover'
                        }} />
                    </div>

                    <div className={styles.title}>{t('onboarding.title')}</div>
                    <div className={styles.description}>
                        {t('onboarding.description')}
                    </div>

                    {error &&
                        <div className={`${styles.error} px-3 py-2 mt-3`}>
                            <img alt={'alert'} src={'/alert.png'} height={'24px'} />
                            <div className={'ms-2'}>{error}</div>
                        </div>
                    }

                    <div className={'mt-4'}>
                        <TextInput
                            name={t('onboarding.corporateGroupName')}
                            internalName={'corporate_group_name'}
                            form={form}
                            setForm={setForm}
                            placeholder={t('onboarding.corporateGroupPlaceholder')}
                        />

                        <TextInput
                            name={t('onboarding.companyName')}
                            internalName={'company_name'}
                            form={form}
                            setForm={setForm}
                            placeholder={t('onboarding.companyNameHint')}
                        />

                        <RadioInput
                            name={t('onboarding.planType')}
                            internalName={'plan'}
                            options={planOptions}
                            form={form}
                            setForm={setForm}
                        />
                    </div>

                    <div className={'mb-4 mt-3'}>
                        <PrimaryButton
                            name={loading ? t('onboarding.processing') : t('onboarding.complete')}
                            onClick={!loading ? handleSubmit : undefined}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
